import { Check } from 'lucide-react';
import styles from './StepNavBar.module.css';

export const WIZARD_STEPS = [
  { id: 0, path: '', label: 'Overview', icon: '◎' },
  { id: 1, path: 'profile', label: 'Practice Profile', icon: '①' },
  { id: 2, path: 'data', label: 'Practice Data', icon: '②' },
  { id: 3, path: 'market', label: 'Market Intelligence', icon: '③' },
  { id: 4, path: 'competition', label: 'Competition', icon: '④' },
  { id: 5, path: 'insights', label: 'Insights & Strategy', icon: '⑤' },
] as const;

interface StepNavBarProps {
  currentStep: number;
  onStepClick: (step: number) => void;
  strategyStatus?: string;
}

export function StepNavBar({ currentStep, onStepClick, strategyStatus }: StepNavBarProps) {
  if (strategyStatus === 'not_started' && currentStep === 0) return null;

  return (
    <div className={styles.nav}>
      {WIZARD_STEPS.map((step) => {
        const active = currentStep === step.id;
        const done = currentStep > step.id;
        return (
          <button
            key={step.id}
            onClick={() => onStepClick(step.id)}
            className={[
              styles.stepBtn,
              active ? styles.stepBtnActive : done ? styles.stepBtnDone : '',
            ]
              .filter(Boolean)
              .join(' ')}
          >
            {done ? <Check size={12} aria-hidden /> : step.icon} {step.label}
          </button>
        );
      })}
    </div>
  );
}
